module.exports = __webpack_public_path__ + "static/media/2016_conf_Power_to_Create_Connect_and_Inspire.e261abfe.png";